import { resetAndSignOut } from 'src/utils/session';

// Signing out wipes everything the app stored in the browser, not just the token.
export function useSignOut() {
  return { signOut: resetAndSignOut };
}
